import { Component, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { CrudCreateComponent } from '../../../shared/components/crud/create/create.component';
import { FormField } from '../../../constants/form.constants';
import { MATERIAS_FIELDS_FORM_CREATE } from '../../../constants/materias.constants';
import { ModalidadService } from '../../../core/modalidad.service';
import { NivelService } from '../../../core/nivel.service';
import { MateriasService } from '../../../core/materias.service';
import { PlanesService } from '../../../core/planes.service';

@Component({
  selector: 'app-materias-create',
  templateUrl: './materias-create.component.html',
  styleUrls: ['./materias-create.component.scss'],
  imports: [CrudCreateComponent],
})
export class MateriasCreateComponent {
  fields: {[name: string]: FormField} = MATERIAS_FIELDS_FORM_CREATE;
  @Input() title: string = '';
  modalidadService = new ModalidadService;
  nivelService = new NivelService;
  planService = new PlanesService;
  apiService = new MateriasService;
  ngOnInit(){
    this.modalidadService.getAllForSelect().subscribe((data)=>{
      this.fields['modalidad_id'].options = data;
    });
    this.nivelService.getAllForSelect().subscribe((data)=>{
      this.fields['nivel_id'].options = data;
    });
    this.planService.getAllForSelect().subscribe((data)=>{
      this.fields['plan_id'].options = data;
    });
  }
}
